import { Routes, mapToCanActivate, mapToResolve, mapToCanDeactivate } from '@angular/router';
import { ApplicationsHomeComponent } from "./components/applications-home/applications-home.component";
import { MasterGuardService } from "../auth/guards/master-guard.service";
import { BaseGuardService } from "../auth/guards/base-guard.service";
import { InternalGuardService } from "../auth/guards/internal-guard.service";
import { SystemPermissionGuardService } from "../auth/guards/system-permission-guard.service";
import { CanDeactivateGuardService } from "../auth/guards/can-deactivate-guard.service";
import { LunaClaimValues, LunaClaimTypes } from "../models/user-identity.model";
import { GuardList } from "../auth/guards/guard-list.enum";
import { ApplicationsResolver } from "./resolvers/applications.resolver";
import { StratigraphicHomeComponent } from './components/stratigraphic/stratigraphic-home/stratigraphic-home.component';
import { StratigraphicApplicationComponent } from './components/stratigraphic/stratigraphic-application/stratigraphic-application.component';
import { OrganizationResolver } from "../common/resolvers/organization.resolver";
import { StratigraphicApplicationReviewComponent } from './components/stratigraphic/stratigraphic-application-review/stratigraphic-application-review.component';
import { StratigraphicReadOnlyComponent } from "./components/stratigraphic/stratigraphic-read-only/stratigraphic-read-only.component";
import { onBaseDocumentTypesByProcessResolver } from "../common/resolvers/onBaseDocumentTypesByProcess.resolver";
import { OnBaseProcessName } from "../common/models/onBaseIntegrationAndMapping.model";
const internalGuards = [BaseGuardService, InternalGuardService];
const systemPermissionGuards = [BaseGuardService, SystemPermissionGuardService];
const deactivateGuards = [CanDeactivateGuardService];





export const APPLICATION_ROUTES: Routes = [
    {
        path: "stratigraphic",
        canActivate: mapToCanActivate([MasterGuardService]),
        component: StratigraphicHomeComponent,
        data: {
            claims: [{ type: LunaClaimTypes.System, value: LunaClaimValues.PrepareStratigraphicWellApplication }, { type: LunaClaimTypes.System, value: LunaClaimValues.ReviewStratigraphicWellApplication }],
            guards: [GuardList.SystemPermissionGuardService]
        },
        children: [
            {
                path: "new",
                component: StratigraphicApplicationComponent,
                resolve: {
                    application: mapToResolve(ApplicationsResolver),
                    organization: mapToResolve(OrganizationResolver),
                    documentTypes: onBaseDocumentTypesByProcessResolver(OnBaseProcessName.StratigraphicApplication)
                },
                canDeactivate: mapToCanDeactivate(deactivateGuards),
                canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    permission: LunaClaimValues.PrepareStratigraphicWellApplication,
                    guards: [GuardList.SystemPermissionGuardService]
                }
            },
            {
                path: "input/:id",
                component: StratigraphicApplicationComponent,
                resolve: {
                    application: mapToResolve(ApplicationsResolver),
                    organization: mapToResolve(OrganizationResolver),
                    documentTypes: onBaseDocumentTypesByProcessResolver(OnBaseProcessName.StratigraphicApplication)
                },
                canDeactivate: mapToCanDeactivate(deactivateGuards),
                canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    permission: LunaClaimValues.PrepareStratigraphicWellApplication,
                    guards: [GuardList.SystemPermissionGuardService]
                }
            },
            {
                path: "review/:id",
                component: StratigraphicApplicationReviewComponent,
                resolve: {
                    application: mapToResolve(ApplicationsResolver),
                    documentTypes: onBaseDocumentTypesByProcessResolver(OnBaseProcessName.StratigraphicApplication)
                },
                canDeactivate: mapToCanDeactivate(deactivateGuards),
                canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    permission: LunaClaimValues.ReviewStratigraphicWellApplication,
                    guards: [GuardList.SystemPermissionGuardService]
                }
            },
            {
                path: "readonly/:id",
                component: StratigraphicReadOnlyComponent,
                resolve: {
                    application: mapToResolve(ApplicationsResolver)
                },
                canDeactivate: mapToCanDeactivate(deactivateGuards),
                canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    permission: LunaClaimValues.ReviewStratigraphicWellApplication,
                    guards: [GuardList.SystemPermissionGuardService]
                }
            },
            {
                path: "",
                component: StratigraphicHomeComponent
            }
        ]
    },
    {
        path: "",
        component: ApplicationsHomeComponent
    }
]
